var _defs, _g, _path, _path2, _path3, _g2, _g3, _g4, _g5, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    zoomAndPan: "magnify",
    viewBox: "0 0 810 809.999993",
    height: 1080,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "eedd800c47"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 137 175 L 673 175 L 673 782.882812 L 137 782.882812 Z M 137 175 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "42b35fbbff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187 26.882812 L 287 26.882812 L 287 129 L 187 129 Z M 187 26.882812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9208532a69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 301 26.882812 L 396 26.882812 L 396 129 L 301 129 Z M 301 26.882812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e934b385c3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 410 26.882812 L 526 26.882812 L 526 129 L 410 129 Z M 410 26.882812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9ad7307bf0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 542 26.882812 L 625 26.882812 L 625 129 L 542 129 Z M 542 26.882812 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eedd800c47)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#313f52",
    d: "M 672.980469 175.449219 L 624.171875 722.054688 L 404.773438 782.851562 L 185.984375 722.136719 L 137.230469 175.449219 L 672.96875 175.441406 L 672.988281 175.441406 Z M 672.980469 175.449219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#71859f",
    d: "M 405.109375 736.378906 L 582.402344 687.253906 L 624.109375 220.15625 L 405.109375 220.148438 Z M 405.109375 736.378906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 310.226562 354.246094 L 405.109375 354.246094 L 405.109375 287.1875 L 236.925781 287.1875 L 238.53125 305.179688 L 255.015625 489.949219 L 405.109375 489.949219 L 405.109375 422.917969 L 316.355469 422.917969 Z M 310.226562 354.246094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 325.34375 523.476562 L 258.015625 523.476562 L 267.410156 628.765625 L 404.796875 666.890625 L 405.109375 666.804688 L 405.109375 597.042969 L 404.816406 597.125 L 330.121094 576.949219 Z M 325.34375 523.476562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#42b35fbbff)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 187.078125 26.882812 L 221.164062 26.882812 L 221.164062 60.546875 L 252.339844 60.546875 L 252.339844 26.882812 L 286.429688 26.882812 L 286.429688 128.824219 L 252.34375 128.824219 L 252.34375 94.6875 L 221.164062 94.6875 L 221.164062 128.824219 L 187.078125 128.824219 Z M 187.078125 26.882812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9208532a69)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 331.25 60.6875 L 301.246094 60.6875 L 301.246094 26.882812 L 395.367188 26.882812 L 395.367188 60.6875 L 365.335938 60.6875 L 365.335938 128.824219 L 331.253906 128.824219 L 331.253906 60.6875 Z M 331.25 60.6875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e934b385c3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 410.296875 26.882812 L 445.832031 26.882812 L 467.695312 62.703125 L 489.535156 26.882812 L 525.089844 26.882812 L 525.089844 128.824219 L 491.152344 128.824219 L 491.152344 78.296875 L 467.695312 114.542969 L 467.105469 114.542969 L 443.648438 78.296875 L 443.648438 128.824219 L 410.296875 128.824219 Z M 410.296875 26.882812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9ad7307bf0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 542.058594 26.882812 L 576.144531 26.882812 L 576.144531 95.128906 L 624.089844 95.128906 L 624.089844 128.824219 L 542.058594 128.824219 Z M 542.058594 26.882812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 404.878906 489.949219 L 487.476562 489.949219 L 479.683594 576.910156 L 404.878906 597.105469 L 404.878906 666.847656 L 542.375 628.765625 L 543.382812 617.425781 L 559.152344 440.910156 L 560.792969 422.917969 L 404.878906 422.917969 Z M 404.878906 489.949219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 404.878906 354.078125 L 404.878906 354.246094 L 566.882812 354.246094 L 568.226562 339.171875 L 571.292969 305.179688 L 572.886719 287.1875 L 404.878906 287.1875 Z M 404.878906 354.078125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.4ae5f6ea8b925254b557422d040487f1.svg";
export { ForwardRef as ReactComponent };